import { useMemo } from 'react';

import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';

import { DEFAULT_PAGE_TITLE } from '../../constants/public';

/**
 * Custom hook to calculate page title based on selected agent, conversation ID, and conversation
 * @param selectedAgentName - The currently selected agent name
 * @param selectedAgentIsDefault - The currently selected agent is default
 * @param currentConversationId - The current conversation ID
 * @param conversationName - The current conversation title
 * @returns Memoized page title string
 */
export const useSelectedAgentAsPageTitle = (
	selectedAgentName: string | undefined,
	selectedAgentIsDefault: boolean | undefined,
	currentConversationId: string | undefined,
	conversationName: string | undefined,
): string => {
	return useMemo(() => {
		if (currentConversationId === EMPTY_CONVERSATION_ID) {
			return selectedAgentName && !selectedAgentIsDefault ? selectedAgentName : DEFAULT_PAGE_TITLE;
		} else if (selectedAgentIsDefault) {
			return conversationName ? DEFAULT_PAGE_TITLE + ' - ' + conversationName : DEFAULT_PAGE_TITLE;
		}
		if (selectedAgentName && conversationName) {
			return selectedAgentName + ' - ' + conversationName;
		}
		if (conversationName) {
			return DEFAULT_PAGE_TITLE + ' - ' + conversationName;
		}
		return selectedAgentName || DEFAULT_PAGE_TITLE;
	}, [selectedAgentName, selectedAgentIsDefault, currentConversationId, conversationName]);
};
